import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import Logout from './Logout';
import * as NotifApi from '../api/NotifApi';

import Profile from './Profile';
import { NotificationPopover } from './NotificationPopover';

const HeaderDropdown = ({ isMobile = false }) => {
  const authSelector = useSelector((state) => state.rrb.authUserReducer);
  const [myProfileModal, setMyProfileModal] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);

  const handleLogout = (e) => {
    e.preventDefault();
    setLogoutModal(true);
  };
  const handleProfile = (e) => {
    e.preventDefault();
    setMyProfileModal(true);
  };

  const allNotifFilter = {
    _page: 1,
    _limit: 10000,
    q: '',
  };
  const [notifications, setNotifications] = useState([]);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  const [notificationModal, setNotificationModal] = useState(false);
  const getAllReceivedNotif = useCallback(async () => {
    try {
      await NotifApi.getAllReceivedNotif(allNotifFilter).then(({ data }) => {
        if (data?.records !== undefined && data.totalRecords !== null) {
          setNotifications(data?.records);
        }
      });
    } catch (error) {
      console.log('error in getting notification counts', error);
    }
  }, []);

  const getAllUnreadNotifCount = useCallback(async () => {
    try {
      await NotifApi.getUnReadNotifCount().then(({ data }) => {
        if (data?.new !== undefined && data?.new !== null) {
          setUnreadNotificationCount(data.new);
        }
      });
    } catch (error) {
      console.log('error in getting unread notification counts', error);
    }
  });

  useEffect(() => {
    getAllReceivedNotif();
    getAllUnreadNotifCount();
  }, []);

  const markAsRead = async (id) => {
    try {
      await NotifApi.readNotif({ notification_id: id }).then(() => {
        setUnreadNotificationCount(0);
      });
    } catch (error) {
      console.log('error in marking as read', error);
    }
  };

  const role = authSelector?.role?.slug;

  return (
    <Fragment>
      {/* <NotificationPopover
        setNotificationModal={setNotificationModal}
        role={role}
        unreadNotificationCount={unreadNotificationCount}
        notificationModal={notificationModal}
        notifications={notifications}
        markAsRead={markAsRead}
        getAllReceivedNotif={getAllReceivedNotif}
      /> */}
      <Dropdown className='nav-link cursor-pointer'>
        <NotificationPopover
          setNotificationModal={setNotificationModal}
          role={role}
          unreadNotificationCount={unreadNotificationCount}
          notificationModal={notificationModal}
          notifications={notifications}
          markAsRead={markAsRead}
          getAllReceivedNotif={getAllReceivedNotif}
        />

        <Dropdown.Toggle
          as={'a'}
          bsPrefix={`nav-link d-flex lh-1 text-reset p-0 text-dark ${
            !isMobile ? 'dropdown-toggle' : ''
          }`}
        >
          <span className={`avatar rounded-circle bg-primary text-white`}>
            {authSelector.first_name.charAt(0).toUpperCase()}
          </span>
          <div className='d-none d-xl-block ps-2'>
            <div>
              {authSelector.first_name} {authSelector.last_name}
            </div>
            <div className='mt-1 small text-muted'>
              {authSelector.role.name}
            </div>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          align='end'
          className='dropdown-menu-end dropdown-menu-arrow-'
        >
          <Dropdown.Item
            as={Link}
            to={''}
            className='fs-3'
            onClick={handleProfile}
          >
            Profile
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            to={''}
            className='fs-3'
            onClick={handleLogout}
          >
            Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      {logoutModal && <Logout {...{ logoutModal, setLogoutModal }} />}
      {myProfileModal && <Profile {...{ myProfileModal, setMyProfileModal }} />}
    </Fragment>
  );
};

export default HeaderDropdown;
